import React from "react";

import { Grid, Typography } from "@material-ui/core";

import {
  Labeled,
  SelectField,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

import { BackButton } from "../../../components/common/BackButton";
import { getUserTypeDescription, getUserTypeOptions } from "./userUtils";
import { UserAclOptions, UserType } from "../../../utils/constants";

const UserShowActions = ({ basePath }) => (
  <TopToolbar>
    <BackButton basePath={basePath} />
  </TopToolbar>
);

export const AddressField = (props) => {
  if (props.record?.address)
    return (
      <div>
        <Typography>{props.record.address.street}</Typography>
        <Typography>
          {props.record.address.city}, {props.record.address.state}{" "}
          {props.record.address.zipCode}
        </Typography>
      </div>
    );
  return "";
};
AddressField.defaultProps = { addLabel: true, label: "Address" };

const StatusTextField = (props) => {
  if (!props.record.status) return null;
  const label = () => {
    switch (props.record.status) {
      case "AVAILABLE":
        return "Available";
      case "TEMP_UNAVAILABLE":
        return "Temporarily Unavailable";
      case "UNAVAILABLE":
        return "Unavailable";
      default:
        return "";
    }
  };

  return label();
};
StatusTextField.defaultProps = { addLabel: true, label: "Availability" };

const UserTitle = ({ record }) => {
  return <span>{record ? `${record.fullName}` : ""}</span>;
};

const AclDisplayField = (record) => {
  // Filter the UserAclOptions to include only those ACLs present in record.acl
  debugger;
  if (record.acl) {
    const displayAcl = UserAclOptions.filter((aclOption) =>
      record.acl.includes(aclOption.id)
    ).map((aclOption) => <li key={aclOption.id}>{aclOption.name}</li>);

    return (
      <ul style={{ listStyleType: "none", paddingLeft: 0 }}>{displayAcl}</ul>
    );
  }
  return null;
};

const UserShowGrid = ({ record, ...props }) => {
  const accounts = [];

  return (
    <Grid container spacing={5}>
      <Grid item xs={12} md={8}>
        <Grid container direction="column" spacing={1}>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12} md={6}>
              <Labeled label="Firs Name">
                <TextField source="firstName" />
              </Labeled>
            </Grid>
            <Grid item xs={12} md={6}>
              <Labeled label="Last Name">
                <TextField source="lastName" />
              </Labeled>
            </Grid>
            <Grid item xs={12} md={6}>
              <Labeled label="Email">
                <TextField source="email" />
              </Labeled>
            </Grid>
            <Grid item xs={12} md={6}>
              <Labeled label="Phone">
                <TextField source="phone" />
              </Labeled>
            </Grid>
            {window.appUser.type !== UserType.CUSTOMER &&
              (record?.type === UserType.CUSTOMER ? (
                <Grid item xs={12} lg={6}>
                  <Labeled label="Account">
                    <SelectField
                      source="accountId"
                      choices={accounts}
                      optionText="businessName"
                    />
                  </Labeled>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <Typography
                    gutterBottom
                    variant="overline"
                    color="textSecondary"
                  >
                    Home Address
                  </Typography>
                  <AddressField source="address" label="Address" />
                </Grid>
              ))}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid container direction="column" spacing={1}>
          <Grid container direction="row" spacing={1}>
            <Grid item xs={12}>
              <Labeled label="Status">
                <TextField source="status" />
              </Labeled>
            </Grid>
            {window.appUser.type !== UserType.CUSTOMER && (
              <Grid item xs={12}>
                <Labeled label="User Type">
                  <SelectField
                    source="type"
                    choices={getUserTypeOptions(record)}
                  />
                </Labeled>
                {getUserTypeDescription(record?.type)}
              </Grid>
            )}
            {record?.type &&
              record.type !== UserType.MANAGER &&
              record.type !== UserType.CUSTOMER &&
              window.appUser.type !== UserType.CUSTOMER && (
                <Grid item xs={12}>
                  <Typography
                    gutterBottom
                    variant="overline"
                    color="textSecondary"
                  >
                    Access Permissions
                  </Typography>
                  <AclDisplayField record={record} />
                </Grid>
              )}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export const UserShow = (props) => {
  return (
    <Show {...props} title={<UserTitle />} actions={<UserShowActions />}>
      <SimpleShowLayout>
        <UserShowGrid />
      </SimpleShowLayout>
    </Show>
  );
};
